import React from "react";
import { formatPercent } from "../../helpers/formatBytes";

function barToneClass(percent) {
	const p = Number(percent) || 0;
	if (p >= 90) return "bg-danger";
	if (p >= 75) return "bg-warning";
	return "bg-primary";
}

export default function MasterProgressMetric({ label, percent, detail, barClass }) {
	const pct = Math.min(100, Math.max(0, Number(percent) || 0));
	const fillClass = barClass || barToneClass(pct);

	return (
		<div>
			<div className="mb-2 flex items-center justify-between gap-2">
				<p className="m-0 text-sm text-default-500 dark:text-default-400">{label}</p>
				<span className="text-sm font-semibold text-default-800 dark:text-default-100">
					{formatPercent(pct)}
				</span>
			</div>
			<div className="h-2.5 w-full rounded-full bg-default-200 dark:bg-default-700">
				<div
					className={`h-2.5 rounded-full transition-all duration-300 ${fillClass}`}
					style={{ width: `${pct}%` }}
				/>
			</div>
			{detail ? (
				<p className="mt-2 m-0 text-xs text-default-500 dark:text-default-400">{detail}</p>
			) : null}
		</div>
	);
}
